export enum MessageId {
    Unknown = 0x00,
    Init1 = 0x01,
    Init1b = 0x0c,
    Init2 = 0x02,
    UpdatePropNA2 = 0x09,
    UpdatePropA2 = 0x0a, // YES this actually has the same message ID as above. This is the msg used now
    NewPlane = 0x05,
    NewPlaneEx = 0x15,
    Init2b = 0x08,
    Init2c = 0x82,
    Init2d = 0x85,
    Init1Start = 0x20,
    Init1End = 0x21,
    Init2Start = 0x22,
    Init2End = 0x23,
    UpdateStart = 0x24,
    UpdateEnd = 0x25,
    LoginResponse = 0x30,
    UpdateTZ = 0x03,
    UpdateSfcLow = 0x89,
    UpdateTZsfc1 = 0x80,
    UpdateTZsfc2 = 0x81,
    UpdateTZ2 = 0x83,
    UpdateTZ3 = 0x84,
    UpdateDZ = 0x04,
    UpdateDZb = 0x86,
    UpdateADSBMed = 0x8d,
    UpdateADSBLow = 0x8e,
    UpdateStatus = 0x07,
    UpdateStatus2 = 0x87,
    UpdateACID = 0x88,
    SelectData = 0x3e,
    Whiteboard = 0x35, // message defined but not used
    ProposedCounts = 0x37,
    WthrProdInfoV2 = 0x38,
    WthrProdStatusV2 = 0x39,
    TimeAdjust = 0x33,
    StartupComplete = 0x3a,
    UpdateEvent = 0x40,
    UpdateURL = 0x41,
    GeneralEvent = 0x42,
    FAIResp = 0x43,
    FAIResp2 = 0x44,
    UpdateEvent2 = 0x45,
    FlightDetails = 0x4c, // legacy binary form of Flight Details
    WeatherProdHistory = 0x50,
    Update3PDIHi = 0x8a,
    Update3PDIMed = 0x8b,
    Update3PDILo = 0x8c,
    FPMIntegration = 0x90, // used to send & receive fpm/desktop interface messages
    SessionShutdown = 0x32,
    ClientText = 0x34,
    MyFleetUpdate = 0x3d,
    MyFleetLastKnownLocationResponse = 0x0b,
    // Airports
    AirportDiversionSummary = 0x46,
    AirportDivertedFlight = 0x47,
    AirportMetar = 0x48,
    AirportTaf = 0x49,
    AirportRvr = 0x4a,
    AirportDelay = 0x4b,
    AirportConfig = 0x4d,
    AirportFlightHolding = 0x4e,
    UpdateImpact = 0x4f
}
